import IconButton from 'components/common/IconButton';
import React, { useEffect, useContext } from 'react';
import { Card, Col, Form, Row } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import { Trans } from 'react-i18next';
import AddressModal from './AddressModal';
import useAddressHook from 'y4/hooks/useAddressHook';
import { ProductContext } from 'context/Context';

const CheckoutShipping = () => {
  const {
    handleNewAddressClick,
    handleEditAddressClick,
    handleDeleteAddressClick,
    loadAddresses
  } = useAddressHook();

  const {
    productsState: { addressItems },
    productsDispatch
  } = useContext(ProductContext);

  const addressChanged = address => {
    productsDispatch({
      type: 'CHANGE_ADDRESS',
      payload: { address }
    });
  };

  useEffect(() => {
    loadAddresses();
  }, []);

  return (
    <>
      <Card className="mb-3">
        <Card.Header className="bg-light">
          <Row className="flex-between-center">
            <Col xs="auto">
              <h5 className="mb-0">
                <Trans ns="commerce">Your Shipping Address</Trans>
              </h5>
            </Col>
            <Col xs="auto">
              <IconButton
                iconClassName="me-2"
                variant="falcon-default"
                size="sm"
                icon="plus"
                transform="shrink-2"
                onClick={() => handleNewAddressClick()}
              >
                <Trans ns="commerce">Add New Address</Trans>
              </IconButton>
            </Col>
          </Row>
        </Card.Header>
        <Card.Body>
          <Row>
            {addressItems.map((item, index) => (
              <Col key={index} md={6} className="mb-3 mb-md-0">
                <Form.Check
                  type="radio"
                  id={`address-${item.id}`}
                  className="mb-0 form-check radio-select"
                >
                  <Form.Check.Input
                    type="radio"
                    name="clientAddress"
                    onChange={() => addressChanged(item)}
                    defaultChecked={index === 0}
                  />
                  <Form.Check.Label className="mb-0 fw-bold d-block">
                    {item.name}
                    <span className="radio-select-content">
                      <span>
                        {item.street}{' '}
                        <span className="d-block mb-0 pt-2">{item.phone}</span>
                      </span>
                    </span>
                  </Form.Check.Label>
                  <Link
                    onClick={() => handleEditAddressClick(item)}
                    className="fs--1"
                  >
                    <Trans ns="commerce">Edit</Trans>
                  </Link>
                  <Link
                    onClick={() => handleDeleteAddressClick(item)}
                    className="fs--1 ms-3"
                  >
                    <Trans ns="commerce">Delete</Trans>
                  </Link>
                </Form.Check>
              </Col>
            ))}
          </Row>
        </Card.Body>
      </Card>
      <AddressModal />
    </>
  );
};

export default CheckoutShipping;
